const DOMAIN_CONFIGS = {
  'diablotools.uk': {
    siteName: 'Diablo Tools',
    company: 'Activision Blizzard, Inc',
    gaTrackingId: 'G-S6JT0P0PY9',
    faviconFolder: 'diablotools',
    siteUrl: 'https://diablotools.uk',
    description: 'Discover essential Diablo tools, build planners, trading resources, interactive maps, and content creators — all in one place.',
    ogImage: '/diablo/d4.jpeg',
    keywords: 'diablo 4, diablo tools, d4 builds, diablo build planner, diablo trading, diablo 2 resurrected, diablo 3, diablo guides, diablo maps, diablo tier list',
    gameName: 'Diablo',
  },
  'arcraiderstools.net': {
    siteName: 'ARC Raiders Tools',
    company: 'Embark Studios AB',
    gaTrackingId: 'G-QQYN9YT011',
    faviconFolder: 'arcraiders',
    siteUrl: 'https://arcraiderstools.net',
    description: 'Discover essential ARC Raiders tools, companion apps, build planners, interactive maps, item databases, and content creators — all in one place.',
    ogImage: '/arc-raiders/arc-raiders-logo.png',
    keywords: 'arc raiders, arc raiders tools, arc raiders builds, arc raiders map, arc raiders items, arc raiders wiki, metaforge, arc raiders tracker, arc raiders guides',
    gameName: 'ARC Raiders',
  },
};

const DEFAULT_CONFIG = {
  siteName: 'Path of Exile Tools',
  company: 'Grinding Gear Games',
  gaTrackingId: 'G-QQYN9YT011',
  faviconFolder: 'poetools',
  siteUrl: 'https://poetools.net',
  description: 'Discover essential Path of Exile tools to enhance your gameplay. Build planners, trading tools, economic insights, labyrinth guides, item filters, and content creators — all in one place.',
  ogImage: '/Path_of_Exile_2_logo.png',
  keywords: 'path of exile, poe tools, poe builds, path of exile 2, poe trade, poe build planner, poe crafting, poe atlas, poe wiki, poe guides',
  gameName: 'Path of Exile',
};

/**
 * Returns domain-specific configuration based on the REACT_APP_DOMAIN env var.
 * Falls back to the default (Path of Exile) config for unknown domains.
 *
 * @param {string} [domain] - Optional domain override. Defaults to process.env.REACT_APP_DOMAIN.
 * @returns {{ siteName: string, company: string, gaTrackingId: string, faviconFolder: string, siteUrl: string, description: string, ogImage: string, keywords: string, gameName: string }}
 */
export const getDomainConfig = (domain) => {
  const resolvedDomain = domain ?? process.env.REACT_APP_DOMAIN;
  return DOMAIN_CONFIGS[resolvedDomain] || DEFAULT_CONFIG;
};

export default getDomainConfig;
